import profileImagePlaceholder from 'assets/images/profile_image_placeholder.png'

const ROUTES = {
  TICKETS: '/tickets',
  ADMIN_PORTAL: '/admin',
  ADMIN_MATCHES: '/admin/matches',
  ADMIN_PROFILES: '/admin/profiles',
  ADMIN_WAITLIST: '/admin/waitlist',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_AI_SEARCH: '/admin/ai-search',
  ADMIN_AI_SEARCH_CLIENTS: '/admin/ai-search/clients',
  ADMIN_AI_SEARCH_PROFILES: '/admin/ai-search/profiles',
  ADMIN_AI_SEARCH_SESSION: '/admin/ai-search/:sessionId',
  ADMIN_ACTIVE_USERS: '/admin/users/active',
  ADMIN_USER_AI: '/admin/users/:id/ai',
  ADMIN_USER: '/admin/users/:id',
  ADMIN_DREAM_BOOTH_IMAGE: '/admin/dream-booth/image',
  ADMIN_DREAM_BOOTH_MODEL: '/admin/dream-booth/model',
  APP_CLIP: '/ac/signup',
  EVENT_CREATE: '/events/create',
  EVENT_LOGIN: '/login/:event_id',
  EVENT_EDIT: '/events/:event_id/edit',
  EVENT: '/events/:event_id',
  EVENT_LIVE: '/live/:event_id',
  FEEDBACK: '/feedback',
  HOST_APPLICATION: '/partnersapplication',
  HOST_INVITE_LOGIN: '/login/hostinvite/:link_id',
  HOST_INVITE: '/hostinvite/:link_id',
  HOST_PORTAL: '/portal',
  HOST_PORTAL_EVENT_PAGE: '/portal/events/:eventId',
  HOST_PROFILE: '/hosts/:link_id?',
  HOST_SIGNUP: '/hostsignup/:uuid',
  LANDING: '/',
  LANDING_INVITE: '/invite/:referralCode',
  LIKES: '/likes/:type?',
  LOGIN: '/login',
  MATCHES: '/matches',
  META_TOUCH: '/meta-touch',
  MEMBERSHIP: '/membership',
  PROFILE: '/profile',
  PUBLIC_HOST_PROFILE: '/host/:link_id?/public',
  RESET_PASSWORD: '/reset_password',
  SETTINGS: '/account',
  SIGNUP: '/signup',
  SOCIAL_ACCOUNT_CALLBACK: '/accounts/:platform',
  TOKEN: '/token',
  VIDEOCHAT: '/videochat/:event_id',
  BACHELORETTE_PROFILE: '/bachelorette/:slug',
  PUBLIC_PROFILE: '/@:slug',
  WALLETS: '/wallets',
}

const EVENT_CONSTANTS = {
  PLACEHOLDER_IMG: `https://picsum.photos/1040/450?grayscale`,
  STATUS: {
    ARCHIVED: 'Archived',
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    STARTED: 'Started',
    CREATED: 'Created',
    UPDATED: 'Updated',
  },
  VISIBILITY: {
    PUBLIC: 'Public',
    PRIVATE: 'Private',
  },
  TYPE: {
    BINARY: 'binary',
    ONE_VARIABLE: 'one_variable',
    NON_BINARY: 'non_binary',
  },
  FORMAT: {
    MATCH: 'match',
    SPEED: 'speed',
  },
  VARIABLE: {
    GAY: 'gay',
    LESBIAN: 'lesbian',
  },
  COVER_IMAGE: {
    WIDTH: 1040,
    HEIGHT: 450,
  },
  VERTICAL_IMAGE: {
    WIDTH: 585,
    HEIGHT: 1266,
  },
  SEXUALITY: {
    GAY: 'gay',
    LESBIAN: 'lesbian',
    NON_BINARY: 'non_binary',
  },
  ORIENTATIONS: {
    STRAIGHT: 'Straight',
    LESBIAN: 'Lesbian',
    GAY: 'Gay',
    NON_BINARY: 'Non-Binary',
  },
  SEXUAL_ORIENTATIONS: {
    STRAIGHT: 'straight',
    LESBIAN: 'lesbian',
    GAY: 'gay',
    Open: 'open',
    LGBTQ_PLUS: 'lgbtq_plus',
  },
  LOCATIONS: {
    NEW_YORK_USA: 'New York, NY, USA',
    LOS_ANGELES_USA: 'Los Angeles, CA, USA',
    TORONTO_CA: 'Toronto, ON, Canada',
    MONTREAL_CA: 'Montreal, QC, Canada',
  },
  NON_ADMIN_START_WEEKS: 2,
  TEXT_TRIM_LENGTH: {
    TITLE: 40,
    DESCRIPTION: 150,
  },
  TICKETS: {
    NEW_EVENT_PARAMS_KEY: 'new-event',
    WAIT_LIST_PARAMS_KEY: 'waitlist',
    JOIN_EVENT_PARAMS_KEY: 'join',
  },
  RECURRING_FREQUENCY: {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
  },
  RECURRING_MAX_QUANTITY: 3,
  PREP_BUFFER_MINUTES: 10,
}

const GENDERS = {
  MALE: 'M',
  FEMALE: 'F',
}
const USER = {
  PROFILE_IMG: {
    WIDTH: 380,
    HEIGHT: 500,
    DEFAULT: profileImagePlaceholder,
  },
  DESIRED_AGE_RANGE: {
    min: 18,
    max: 100,
  },
}

const AUTH_STATUS = {
  LOGGED_OUT: 'LOGGED_OUT',
  LOGGED_IN: 'LOGGED_IN',
  LOGGING_IN: 'LOGGING_IN',
}

const AUTH_ACTIONS = {
  LOGIN: 'LOGIN',
  LOGGING: 'LOGGING',
  LOGOUT: 'LOGOUT',
  UPDATE_USER: 'UPDATE_USER',
  PARTIAL_UPDATE_USER: 'PARTIAL_UPDATE_USER',
}

const LOGIN_METHODS = {
  FB_LOGIN: 'facebook',
  PASSWORD_LOGIN: 'password',
}

const STORAGE = {
  TOKEN: 'token',
  USER_ID: 'userId',
}

const ANIMATION = {
  SOFT_SPRINT: { type: 'spring', stiffness: 300, damping: 30 },
}

const HOST_PORTAL_TABS = {
  TICKET_SALES: 'Ticket Sales',
  UPDATE_INFO: 'Update Event Info',
}

const APP_CONTAINER = {
  WIDTH_CLASS: 'max-w-laptop mx-auto',
}

const WAITLIST_STATUS_CONFIG = {
  'subscription-failed': {
    state: 'Sub failed',
    actions: [],
    width: 24,
  },
  'subscription-cancelled': {
    state: 'Sub cancelled',
    actions: [],
    width: 30,
  },
  pending: {
    state: 'No Decision Made',
    actions: ['pre-approved', 'database-pending', 'user-declined', 'no', 'maybe'],
    width: 40,
  },
  'database-pending': {
    state: 'DB Pending',
    actions: ['pre-approved', 'database-approved', 'user-declined', 'no', 'maybe'],
    width: 40,
  },
  'database-approved': {
    state: 'DB Approved',
    actions: ['pre-approved', 'database-pending', 'user-declined', 'no', 'maybe'],
    width: 40,
  },
  'user-declined': {
    state: 'User Declined',
    actions: ['pre-approved', 'database-pending', 'no', 'maybe'],
    width: 40,
  },
  maybe: {
    state: 'maybe',
    actions: ['pre-approved', 'database-pending', 'user-declined', 'no'],
    width: 20,
  },
  no: {
    state: 'No',
    actions: ['pre-approved', 'database-pending', 'user-declined', 'maybe'],
    width: 20,
  },
  'pre-approved': {
    state: 'Pre-approved',
    actions: ['yes', 'pre-approved', 'database-pending', 'user-declined', 'no', 'maybe'],
    width: 40,
  },
  yes: {
    state: 'Approved',
    actions: [],
    width: 40,
  },
  all: {
    state: 'All',
    actions: [],
    width: 20,
  },
}

export const WAITLIST_STATUS = {
  YES: 'yes',
  NO: 'no',
  MAYBE: 'maybe',
  PRE_APPROVED: 'pre-approved',
  PENDING: 'pending',
  DATABASE_PENDING: 'database-pending',
  DATABASE_APPROVED: 'database-approved',
  SUBSCRIPTION_PAUSED: 'subscription-paused',
}

const MEMBERSHIP_TYPES = {
  GENERAL: 'general',
  FOUNDING_BOARD: 'founding-board',
  FOUNDING_MEMBER: 'founding-member',
}

export const MEMBERSHIP_STATUS = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  SUSPENDED: 'suspended',
}

const MEMBERSHIP_VALUES = {
  general: 'General',
  'lifetime-free': 'Life Time Free',
  'founding-board': 'Founding Board',
  'founding-member': 'Founding Member',
  preferred: 'Preferred',
  partnerships: 'Partnerships',
  friends: 'Friends',
}

const H_NUMBERS = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1]

const constants = {
  AUTH_STATUS,
  AUTH_ACTIONS,
  LOGIN_METHODS,
  ROUTES,
  EVENT_CONSTANTS,
  GENDERS,
  USER,
  STORAGE,
  ANIMATION,
  HOST_PORTAL_TABS,
  APP_CONTAINER,
  WAITLIST_STATUS_CONFIG,
  WAITLIST_STATUS,
  MEMBERSHIP_TYPES,
  MEMBERSHIP_VALUES,
  H_NUMBERS,
}

export default constants

export { ROUTES, USER, GENDERS, STORAGE, ANIMATION, APP_CONTAINER }
